function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTroubleshoot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "troubleshoot") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3697",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12936"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    "data-name": "Path 384",
    d: "m5.663 5.418 2.47 2.47.745-.746-2.47-2.47v-1.98L2.686.008 1 1.7l2.682 3.718z",
    transform: "translate(2.003 2.991)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    "data-name": "Path 385",
    d: "M13.6.926a3.244 3.244 0 0 0-.632 3.614l-7.429 7.427a3.234 3.234 0 0 0-3.614.631 3.171 3.171 0 0 0-.618 3.6l2.11-2.11 1.491 1.491L2.8 17.691a3.164 3.164 0 0 0 3.6-.619 3.242 3.242 0 0 0 .632-3.614l7.425-7.427A3.241 3.241 0 0 0 18.07 5.4a3.168 3.168 0 0 0 .618-3.6l-2.11 2.11-1.49-1.492L17.2.307a3.169 3.169 0 0 0-3.6.619z",
    transform: "translate(2.002 2.999)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    "data-name": "Path 386",
    d: "m266.962 268.212 2.236-2.236.749.749-2.236 2.236z",
    transform: "translate(-254.593 -253.608)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    "data-name": "Path 387",
    d: "m314.377 315.63-4.9-4.9 2.236-2.236 4.9 4.9z",
    transform: "translate(-295.613 -294.633)",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTroubleshoot);
export default __webpack_public_path__ + "static/media/troubleshoot.86a73c606c4aa1c35ffa1335091419dd.svg";
export { ForwardRef as ReactComponent };